export default __webpack_public_path__ + "static/media/kitchen3-afterA-1920w.7769cc05.avif";